import { portNumbers } from "get-port"
// @ts-ignore
import { anvil } from "prool/instances"
import type { Chain, Hex } from "viem"
import { getFreePort, getFundedAccount } from "./utils"

export type NetworkArgs = {
  rpcPort?: number
  rpcUrl?: string
  chainId?: string
  name?: string
  privateKey?: Hex
  forkUrl?: string
}
export type Network = Awaited<ReturnType<typeof toNetwork>>
export const toNetwork = async (parameters?: NetworkArgs) => {
  const gotPort = await getFreePort(5500, 5989)

  const {
    rpcPort = gotPort,
    rpcUrl = `http://127.0.0.1:${rpcPort}`,
    chainId = String(rpcPort),
    name = `chain-${chainId}`,
    privateKey = getFundedAccount().privateKey,
    forkUrl = undefined
  } = parameters ?? {}

  const chain: Chain = {
    id: Number(chainId),
    name: `Chain ${chainId}`,
    nativeCurrency: {
      name: "Ether",
      symbol: "ETH",
      decimals: 18
    },
    rpcUrls: {
      default: {
        http: [rpcUrl]
      }
    }
  }

  const instance = anvil({
    hardfork: "Prague",
    chainId: rpcPort,
    port: rpcPort,
    codeSizeLimit: 1000000000000,
    allowOrigin: "*",
    forkUrl
  })

  await instance.start()

  instance.on("stderr", console.error)

  return {
    instance,
    chain,
    rpcUrl,
    rpcPort,
    chainId,
    name,
    privateKey
  }
}
